export default function year(current_year) {
  switch (current_year) {
    case 1:
      return ("First Year")
    case 2:
      return ("Second Year")
    case 3:
      return ("Third Year")
    case 4:
      return ("Fourth Year")
    case 5:
      return ("IMGian")
    default:
      return ("IMGian")
  }
}